import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import SearchBox from 'components/common/SearchBox';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { faFileExport, faPlus } from '@fortawesome/free-solid-svg-icons';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import AdvanceTable from 'components/base/AdvanceTable';
import { ColumnDef } from '@tanstack/react-table';
import { Link, useNavigate } from 'react-router-dom';
import Avatar from 'components/base/Avatar';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { deleteService, getService } from 'services/services';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { formatDate, validationErrorFromAPI } from 'helpers/utils';
import { toast } from 'react-toastify';
import Loader from 'helpers/Loader';
import { Form } from 'react-bootstrap';

interface ChallanList {
  id: number;
  challan_no: string;
  created_at: string;
  site: {
    site_name: string;
    site_id: string;
    address: string;
    contractor: {
      first_name: string;
      last_name: string;
    };
    createuser: {
      name: string;
    };
  };
}

const DispatchChallanTable = () => {
  // const navigate = useNavigate();
  const [challanlList, setChallanlList] = useState([]);
  const [challanId, setChallanId] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(true);

  const confirmAlert = (id: any) => {
    setShowAlert(true);
    setChallanId(id);
  };
  const removeApi = async () => {
    const response = await deleteService(`challan/${challanId}`);
    if (response?.status === 200) {
      toast.success('Remove SuccessFully', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light'
      });
      fetch();
      setShowAlert(false);
      setChallanId('');
    } else if (response?.status === 500) {
      validationErrorFromAPI(response.data);
    }
  };
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const membersTablecolumns: ColumnDef<ChallanList>[] = [
    {
      accessorKey: 'id',
      header: 'Challan ID',
      meta: {
        headerProps: { style: { width: '10%' } },
        cellProps: { className: 'text-body' }
      }
    },
    {
      accessorKey: 'challan_no',
      header: 'Challan No.',
      cell: ({ row: { original } }) => {
        const { challan_no, id } = original;
        return (
          <Link
            to={`/challan/${id}`}
            className="text-decoration-none fw-bold fs-8"
          >
            {challan_no}
          </Link>
        );
      },
      meta: {
        headerProps: { style: { width: '10%' } },
        cellProps: { className: 'text-body' }
      }
    },
    {
      accessorKey: 'site.site_id',
      header: 'Site ID',
      meta: {
        headerProps: {
          style: { width: '15%', minWidth: '200px' }
        },
        cellProps: { className: 'white-space-nowrap' }
      }
    },
    {
      accessorKey: 'site.site_name',
      header: 'Site Name',
      meta: {
        headerProps: {
          style: { width: '15%', minWidth: '200px' }
        },
        cellProps: { className: 'white-space-nowrap' }
      }
    },
    {
      accessorKey: 'site.site_name',
      header: 'Contractor Name',
      cell: ({ row: { original } }) => {
        const { first_name, last_name } = original.site.contractor;
        return (
          <div className="'white-space-nowrap'">
            {`${first_name} ${last_name}`}
          </div>
        );
      },
      meta: {
        headerProps: {
          style: { width: '15%', minWidth: '200px' }
        },
        cellProps: { className: 'white-space-nowrap' }
      }
    },
    {
      accessorKey: 'site.address',
      header: 'Site Address',
      meta: {
        headerProps: {
          style: { width: '15%', minWidth: '200px' }
        },
        cellProps: { className: 'white-space-nowrap' }
      }
    },
    {
      accessorKey: 'createuser.name',
      header: 'Created By',
      meta: {
        headerProps: {
          style: { width: '15%', minWidth: '200px' }
        },
        cellProps: { className: 'white-space-nowrap' }
      }
    },
    {
      accessorKey: 'created_at',
      header: 'Create date',
      meta: {
        headerProps: { style: { width: '10%' } },
        cellProps: { className: 'text-body' }
      },
      cell: ({ row: { original } }) => {
        return <>{formatDate(original.created_at)}</>;
      }
    },
    {
      id: 'action',
      cell: ({ row: { original } }) => {
        const { id } = original;
        return (
          <RevealDropdownTrigger>
            <RevealDropdown>
              <ActionDropdownItems
                // editAction={() => navigate(`/contractors/create-new/${id}`)}
                removeAction={() => confirmAlert(id)}
              />
            </RevealDropdown>
          </RevealDropdownTrigger>
        );
      },
      meta: {
        headerProps: { style: { width: '10%' }, className: 'text-end' },
        cellProps: { className: 'text-end' }
      }
    }
  ];

  const table = useAdvanceTable({
    data: challanlList,
    columns: membersTablecolumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false
  });

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    setLoading(true);
    const response = await getService('challan');
    if (response.status === 200) {
      setLoading(false);
      setChallanlList(response.data);
    } else if (response?.status === 500) {
      setLoading(false);
      validationErrorFromAPI(response.data);
    } else {
      setLoading(false);
    }
  };
  if (loading) return <Loader />;
  return (
    <div>
      {showAlert && (
        <ConfirmationModal
          name={'Challan'}
          show={showAlert}
          handleClose={() => setShowAlert(false)}
          handleAction={() => removeApi()}
        />
      )}
      <div className="mb-9">
        <h2 className="mb-5">Dispatch/Challan Table</h2>

        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <Row className="g-3">
              <Col xs="auto">
                <SearchBox
                  placeholder="Search"
                  onChange={handleSearchInputChange}
                />
              </Col>
              <Col xs="auto">
                <Form.Select
                  name="Material Filter"
                  // onChange={e => handleStateChange(e.target.value)}
                >
                  <option value="0">Select Contractor</option>
                  {/* {stateList.length > 0 &&
                    stateList.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {`${item.sbu_name} - ${item.state.name}`}
                      </option>
                    ))} */}
                </Form.Select>
              </Col>
              <Col xs="auto">
                <Form.Select
                  name="Material Filter"
                  // onChange={e => handleStateChange(e.target.value)}
                >
                  <option value="0">Select Challan</option>
                  {/* {stateList.length > 0 &&
                    stateList.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {`${item.sbu_name} - ${item.state.name}`}
                      </option>
                    ))} */}
                </Form.Select>
              </Col>
              <Col xs="auto">
                <Form.Select
                  name="Material Filter"
                  // onChange={e => handleStateChange(e.target.value)}
                >
                  <option value="0">Select Site</option>
                  {/* {stateList.length > 0 &&
                    stateList.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {`${item.sbu_name} - ${item.state.name}`}
                      </option>
                    ))} */}
                </Form.Select>
              </Col>
              <Col
                xs="auto"
                className="scrollbar overflow-hidden-y flex-grow-1"
              ></Col>
              <Col xs="auto">
                <Button variant="link" className="text-body me-4 px-0">
                  <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
                  Export
                </Button>
                {/* <Link
                  className="btn btn-primary px-5"
                  to="/contractors/create-new"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Add contractor
                </Link> */}
              </Col>
            </Row>
          </div>

          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
            <MembersTable />
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export const MembersTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter pagination />
    </div>
  );
};

export default DispatchChallanTable;
